module.exports = __webpack_public_path__ + "static/kamisato-ayato-selected-749c9e8d08ba5139e5a4ce249c1c85fe.webp";